import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { GitBranch } from 'lucide-react';

function ConditionNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const field = (config.field as string) ?? '';
  const operator = (config.operator as string) ?? '';
  const value = (config.value as string) ?? '';

  const summary =
    field && operator
      ? `${field} ${operator} ${value}`
      : null;

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-zinc-500 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-zinc-500" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <GitBranch size={14} className="text-zinc-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Condition
        </span>
      </div>
      <div className="px-3 py-2">
        <p className="text-xs text-zinc-800 font-medium truncate">
          {summary || <span className="italic text-zinc-400">Not configured</span>}
        </p>
      </div>
      {/* True branch — right */}
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        className="!bg-emerald-500"
        style={{ top: '50%' }}
      />
      {/* False branch — left */}
      <Handle
        type="source"
        position={Position.Left}
        id="false"
        className="!bg-red-400"
        style={{ top: '50%' }}
      />
    </div>
  );
}

export default memo(ConditionNode);
